import concierge from './concierge.svg';
import elevator from './elevator.svg';
import children_area from './children_area.svg';
import landscape_decore from './landscape_decore.svg';
import sport_area from './sport_area.svg';
import spa from './spa.svg';
import fitness from './fitness.svg';
import pool from './pool.svg';
import kindergarten from './kindergarten.svg';
import tennis_court from './tennis_court.svg';
import recreation_zone from './recreation_zone.svg';
import fountain from './fountain.svg';
import garden from './garden.svg';
import helicopter_landing_area from './helicopter_landing_area.svg';
import commercial_property from './commercial_property.svg';
import cctv_surveillance from './cctv_surveillance.svg';
import sauna from './sauna.svg';
import billiards from './billiards.svg';
import restaurant from './restaurant.svg';
import kpp from './kpp.svg';

import is_children_room from './is_children_room.svg';
import is_conference_hall from './is_conference_hall.svg';
import is_wellness_building from './is_wellness_building.svg';
import is_panoramic_glazing from './is_panoramic_glazing.svg';
import is_beach from './is_beach.svg';
import is_walking_area from './is_walking_area.svg';
import is_operated_roof from './is_operated_roof.svg';
import is_garage from './is_garage.svg';
import is_acs_system from './is_acs_system.svg';
import is_landscape_park from './is_landscape_park.svg';
import is_management_company from './is_management_company.svg';

export {
  concierge,
  elevator,
  children_area,
  landscape_decore,
  sport_area,
  spa,
  fitness,
  pool,
  kindergarten,
  tennis_court,
  recreation_zone,
  fountain,
  garden,
  helicopter_landing_area,
  commercial_property,
  cctv_surveillance,
  sauna,
  restaurant,
  billiards,
  kpp,

  is_children_room,
  is_conference_hall,
  is_wellness_building,
  is_panoramic_glazing,
  is_beach,
  is_walking_area,
  is_operated_roof,
  is_garage,
  is_acs_system,
  is_landscape_park,
  is_management_company
};



// WEBPACK FOOTER //
// ./src/assets/images/features/index.js